import dynamic from 'next/dynamic';
import * as React from 'react';

export const LandingSideBar = dynamic<any>(
  () => import('./LandingSidebarBase').then((mod) => mod.LandingSideBar),
  { loading: () => <div />, ssr: false }
);
